var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_1747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.19 0 0 11.19 0 25C0 38.81 11.19 50 25 50C38.81 50 50 38.81 50 25C50 11.19 38.81 0 25 0ZM25 48C12.32 48 2 37.68 2 25C2 12.32 12.32 2 25 2C37.68 2 48 12.32 48 25C48 37.68 37.68 48 25 48Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 32H16.5C15.95 32 15.5 32.45 15.5 33C15.5 33.55 15.95 34 16.5 34H33.5C34.05 34 34.5 33.55 34.5 33C34.5 32.45 34.05 32 33.5 32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19C22 16.79 20.21 15 18 15C15.79 15 14 16.79 14 19C14 21.21 15.79 23 18 23C20.21 23 22 21.21 22 19ZM16 19C16 17.9 16.9 17 18 17C19.1 17 20 17.9 20 19C20 20.1 19.1 21 18 21C16.9 21 16 20.1 16 19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 15C29.79 15 28 16.79 28 19C28 21.21 29.79 23 32 23C34.21 23 36 21.21 36 19C36 16.79 34.21 15 32 15ZM32 21C30.9 21 30 20.1 30 19C30 17.9 30.9 17 32 17C33.1 17 34 17.9 34 19C34 20.1 33.1 21 32 21Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_1747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.82a951ead5202786e54ccb8abe3706d8.svg";
export { ForwardRef as ReactComponent };